import { TCreateContactResDto } from "@/api/services/main/contact/dtos/create-contact.dto";
import { clientApi } from "@/utils/api";

export const createContactApi = async (formData: FormData): Promise<TCreateContactResDto> => {
  const rs = await clientApi.post<TCreateContactResDto>("/contacts", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return rs.data;
};
